import script from "./OverviewSectionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewSectionCard.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewSectionCard.vue?vue&type=style&index=0&id=1613fdd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1613fdd9"]])

export default __exports__